import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle, FaHourglassHalf, FaTimesCircle } from 'react-icons/fa';
import './ClientStatusPage.css'; // We will create this CSS file

import { useAlertDialog } from '../contexts/AlertDialogContext';

const ClientStatusPage = () => {
  const { t } = useTranslation();
  const { openAlertDialog } = useAlertDialog();

  const handleButtonClick = async (status) => {
    // Lire le lien_id depuis les paramètres de l'URL
    const queryParams = new URLSearchParams(window.location.search);
    const lien_id = queryParams.get('lien_id');

    // Fait correspondre le statut du bouton au type de clic de la base de données
    const clickTypeMap = {
      paid: 'PAIEMENT_EFFECTUE',
      pending: 'PAIEMENT_EN_ATTENTE',
      not_interested: 'NON_INTERESSE'
    };

    const click_type = clickTypeMap[status];

    if (!click_type) {
      console.error("Statut de clic non valide:", status);
      return;
    }

    try {
      const response = await fetch('https://back-desalpe.onrender.com/api/click-events', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            click_type: click_type,
            lien_id: lien_id // Envoyer l'ID du lien
        }),
      });

      const responseData = await response.json();

      if (response.ok) {
        openAlertDialog(t(`clientStatus.feedback_${status}`), 'Statut du Client', null, false); // Pas de bouton OK
      } else {
        console.error('--- ClientStatusPage: La requête a échoué ---', response.status, responseData);
        openAlertDialog(`Erreur: ${responseData.message}`, 'Erreur');
      }
    } catch (error) {
      console.error('--- ClientStatusPage: Erreur de fetch ---', error);
      openAlertDialog('Impossible d\'envoyer les données de suivi.', 'Erreur Réseau');
    }
  };

  return (
    <div className="client-status-container">
      <h2>{t('clientStatus.title')}</h2>
      <p>{t('clientStatus.instruction')}</p>
      <div className="button-group">
        <button className="status-button success" onClick={() => handleButtonClick('paid')}>
          <FaCheckCircle /> {t('clientStatus.option_paid')}
        </button>
        <button className="status-button pending" onClick={() => handleButtonClick('pending')}>
          <FaHourglassHalf /> {t('clientStatus.option_pending')}
        </button>
        <button className="status-button not_interested" onClick={() => handleButtonClick('not_interested')}>
          <FaTimesCircle /> {t('clientStatus.option_not_interested')}
        </button>
      </div>
    </div>
  );
};

export default ClientStatusPage;
